import React from "react";
import { NavLink, Link, useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Plus, ArrowUpRight, ClipboardList, LineChart } from "lucide-react";
import { Logo } from "../Logo";

function FilterLink({ to, active, label, icon: Icon, testid }) {
  return (
    <Link to={to} data-testid={testid}
      className="group relative flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200"
      style={active ? { background: "rgba(182,225,79,.14)", color: "#EAF2D6" } : { color: "rgba(255,255,255,.62)" }}>
      <Icon size={18} strokeWidth={1.5} style={{ color: active ? "#B6E14F" : undefined }} />
      <span>{label}</span>
    </Link>
  );
}

export default function SalesSidebar() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const filter = new URLSearchParams(search).get("filter");
  const onHome = pathname === "/sales" && !filter;
  return (
    <aside className="w-64 shrink-0 h-screen sticky top-0 flex flex-col px-4 py-5" style={{ background: "var(--grad-ink)" }}>
      <div className="flex items-center gap-2 px-2 py-1.5 mb-1">
        <Logo height={18} bare />
        <span className="ml-auto text-[10px] font-bold uppercase tracking-wider rounded-full px-2 py-0.5" style={{ background: "rgba(182,225,79,.18)", color: "#B6E14F" }}>Sales</span>
      </div>
      <p className="px-2 text-[11px] mb-4" style={{ color: "rgba(255,255,255,.4)" }}>Sales Director</p>

      <button onClick={() => navigate("/sales/new")} data-testid="sales-new-cta"
        className="w-full flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm font-semibold transition-all mb-3"
        style={{ background: "var(--grad-green)", color: "#16180F" }}>
        <Plus size={17} strokeWidth={2.25} /> New Social Health Check
      </button>

      <nav className="space-y-0.5 flex-1">
        <FilterLink to="/sales" active={onHome} label="Home" icon={LayoutDashboard} testid="sales-nav-home" />
        <FilterLink to="/sales?filter=drafts" active={filter === "drafts"} label="Draft Analyses" icon={ClipboardList} testid="sales-nav-draft-analyses" />
        <FilterLink to="/sales?filter=completed" active={filter === "completed"} label="Completed Reports" icon={LineChart} testid="sales-nav-completed-reports" />
      </nav>

      <div className="pt-4 mt-4 space-y-1 border-t" style={{ borderColor: "rgba(255,255,255,.1)" }}>
        <a href="/ops" data-testid="sales-goto-ops"
          className="flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all" style={{ color: "rgba(255,255,255,.55)" }}>
          <ArrowUpRight size={17} strokeWidth={1.5} /> Managed Operations
        </a>
        <a href="/app" data-testid="sales-exit"
          className="flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all" style={{ color: "rgba(255,255,255,.55)" }}>
          <ArrowUpRight size={17} strokeWidth={1.5} /> Exit to Growth app
        </a>
      </div>
    </aside>
  );
}
